<mat-card>
    <mat-card-header>
        <mat-card-title>Simulation</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div fxLayout="row" class="action-bar">
            <p-calendar class="action-bar-item" [(ngModel)]="operatingDate" [showIcon]="true" [maxDate]="maxOperatingDate"
                (onSelect)="onOperatingDateSelected($event)"></p-calendar>
            <p-dropdown fxFlex="0 0 auto" class="action-bar-item" [options]="simulationTypes"
                [(ngModel)]="simulationType" optionLabel="label" optionValue="value" optionDisabled="!licensed"
                (onChange)="onSimulationTypeChange($event)"></p-dropdown>
            <button fxFlex="0 0 auto" [disabled]="running" pButton pRipple type="button"
                class="p-button-raised menu-button action-bar-item " label="Check Status" icon="pi pi-cloud"
                (click)="doCheckStatus()">
            </button>
            <div fxFlex="1 1 auto"></div>
            <p-fileUpload #fileChooser fxFlex="0 0 auto" name="simulationData[]" [disabled]="running || loading"
                chooseLabel="Upload Simulation File" auto="true" class="menu-button action-bar-item "
                customUpload="true" mode="basic" (uploadHandler)="handleSimulationFileUpload($event)" accept=".xlsx"
                maxFileSize="10000000">
            </p-fileUpload>
            <button fxFlex="0 0 auto" [disabled]="!loadedXlsxBase64Data || running" pButton pRipple
                type="button" class="p-button-raised menu-button action-bar-item " label="Run Simulation"
                icon="pi pi-send" (click)="doRunSimulation()">
            </button>
            <a fxFlex="0 0 auto" [href]="downloadTemplateUrl" class="download-link action-bar-item "
                download="SimulationDataTemplate">
                <!-- style="position: fixed;left: 45%;top: 50%;"> -->
                <mat-icon [inline]="true" class="download-icon">get_app</mat-icon>Download Template
            </a>
        </div>
        <div fxLayout="column">
            <mat-card>
                <p-table *ngIf="errorMessages && errorMessages.length > 0" [value]="errorMessages">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Errors</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td class="data-error">{{rowData}}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </mat-card>
            <mat-card>
                <p-tabView class="tab-group">
                    <p-tabPanel *ngFor="let recordModel of recordModels">
                        <ng-template pTemplate="header">
                            <span>{{recordModel.displayName}}</span>
                        </ng-template>
                        <p-table [columns]="recordModel.fields" [value]="recordModel.data" [loading]="loading">
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th *ngFor="let field of columns">
                                        {{field.displayName}}
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns">
                                <tr>
                                    <td *ngFor="let field of columns" [class.data-error]="rowData[field.name].isError">
                                        {{rowData[field.name].value}}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </p-tabPanel>
                </p-tabView>
            </mat-card>
        </div>
    </mat-card-content>
</mat-card>
<p-confirmDialog header="Confirmation" icon="pi pi-info" [style]="{width: '50vw'}"></p-confirmDialog>